











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoteSettingsMenu_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalVotes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxVotesPerGroup",
      "storageKey": null
    }
  ],
  "type": "RetrospectiveMeeting",
  "abstractKey": null
};

(node ).hash = "deda61e97e8917d62a8f6a363e0233fd";

export default node;
